import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Dashboard from "../dashboard/Dashboard";
import Joyride, { Step, CallBackProps, STATUS } from "react-joyride";
import axiosInstance from "../../axiosInstance";

const steps: Step[] = [
  {
    target: ".side-panel-item-stock",
    content: "Start by adding stocks to your inventory here.",
    placement: "right",
    disableBeacon: true,
  },
  {
    target: ".side-panel-item-orders",
    content: "Track and manage all your orders here.",
    placement: "right",
    disableBeacon: true,
  },
  {
    target: ".side-panel-item-payments",
    content: "Monitor your payments and transactions here.",
    placement: "right",
    disableBeacon: true,
  },
  {
    target: ".side-panel-item-customers",
    content: "Check your customer ranking and manage your customers here.",
    placement: "right",
    disableBeacon: true,
  },
  {
    target: ".side-panel-item-dashboard",
    content: "Get an overview of your business from the dashboard.",
    placement: "right",
    disableBeacon: true,
  },
];

const DashboardMain: React.FC = () => {
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    // Fetch stock to check if it's empty
    const checkStock = async () => {
      try {
        const res = await axiosInstance.get("/products/me");
        const products = res?.data?.data?.products || [];
        setShowTour(products.length === 0);
      } catch (error) {
        setShowTour(false);
      }
    };
    checkStock();
  }, []);

  // Only hide the tour when user finishes or skips it
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setShowTour(false);
    }
  };

  return (
    <div className="home-page">
      {showTour && (
        <Joyride
          steps={steps}
          continuous
          showSkipButton
          run={true}
          callback={handleJoyrideCallback}
          styles={{
            options: {
              zIndex: 9999,
              primaryColor: "#089B14",
            },
            buttonNext: {
              backgroundColor: "#089B14",
              color: "#fff",
            },
            buttonBack: {
              color: "#089B14",
            },
          }}
          locale={{
            last: "Finish",
            next: "Next",
            skip: "Skip",
            back: "Back",
            close: "Close",
          }}
        />
      )}
      <Sidebar activeTab="Dashboard" forceOpen={true} />
      <Dashboard />
    </div>
  );
};

export default DashboardMain;
